module.exports = __webpack_public_path__ + "static/img/occupational-assessment.3c6b066.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/career_panorama/occupational-assessment.png
// module id = j5nd
// module chunks = 1